import { z } from 'zod';

import { StrictAddress, USStrictAddress } from '../Address';
import { PropertyId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ModifyPropertyAddressEvent = BaseLoanEvent.extend({
  type: z.literal('modifyPropertyAddress'),
  propertyId: PropertyId,
  originalAddress: StrictAddress,
  newAddress: USStrictAddress,
});
export type ModifyPropertyAddressEvent = z.infer<typeof ModifyPropertyAddressEvent>;
